import { shortState } from '../../../utils/vuex'
import { KAccount } from '../../../models/k-user'

// 是否为已验证手机号用户
function isValidMobile(state) {
  const { info } = state
  if (info && info.uid > 0 && info.isValidMobile > 0) {
    return true
  }
  return false
}

function isRealName(state) {
  return !!state.info && state.info.isRealName
}

export default {
  myInfo: shortState('info', KAccount({ uid: 0, nick: '' })),
  myUid: shortState('info/uid', 0),
  myNick: shortState('info/nick', ''),
  myLogo: shortState('info/logoSrc', ''),
  myMobile: shortState('info/mobile', ''),
  isValidMobile,
  isRealName,
  isLogined(state) {
    const {info} = state
    return !!info && info.uid > 0
  }
}
